import {IGlobalQuery} from 'src/app/models'

export enum ECompanyStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ECompanyType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export interface ICompany {
  id: string
  code: string
  name: string
  organization_id: string
  organization_name: string
  type: keyof typeof ECompanyType
  address: string
  cs_number: string
  utc_offset: string
  is_active: boolean
}

export interface ICompanyQuery extends IGlobalQuery {
  organization_ids?: string[]
  type?: string
  is_active?: boolean
}

export interface ICompanyForm {
  code: string
  name: string
  organization_id: string
  type: keyof typeof ECompanyType
  address: string
  description: string
  cs_number: string
  utc_offset: string
  is_active: boolean
}
